import type { DefaultTheme } from 'styled-components';
import type { FeatureType } from '../types';
import { getCssVariableValue } from '../../../helpers/getCssVariableValue';

type MapFeatureStyles = {
  [key in FeatureType]: google.maps.Data.StyleOptions;
};

export const setStyles = (map: google.maps.Map, theme: DefaultTheme) => {
  const mapFeatureStyles: MapFeatureStyles = {
    mapBackgroundOverlay: {
      fillColor: getCssVariableValue(theme.palette.backgroundSecondaryBase),
      fillOpacity: 1,
      strokeWeight: 0,
    },
    buildingBoundary: {
      fillColor: getCssVariableValue(theme.palette.backgroundBrandStatic),
      fillOpacity: 0.4,
      strokeWeight: 0,
    },
    propertyBoundary: {
      fillColor: getCssVariableValue(theme.palette.backgroundBrandStatic),
      fillOpacity: 0.2,
      strokeColor: getCssVariableValue(theme.palette.backgroundBrandStatic),
      strokeWeight: 2,
    },
    schoolCatchmentZone: {
      fillColor: getCssVariableValue(theme.palette.backgroundBrandStatic),
      fillOpacity: 0.2,
      strokeWeight: 0,
    },
  };

  const isStyledFeature = (featureType: unknown): featureType is FeatureType => {
    return typeof featureType === 'string' && Object.keys(mapFeatureStyles).includes(featureType);
  };

  map.data.setStyle((feature) => {
    const featureType = feature.getProperty('type');
    if (isStyledFeature(featureType)) {
      return mapFeatureStyles[featureType];
    }
    return {};
  });
};
